
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint react/no-unescaped-entities: 0 */
import Head from 'next/head'

import css from './privacy-policy.module.scss'

const PrivacyPolicy = () => {
  return (
    <main className={css.container}>
      <Head>
        <title>Markato | Privacy Policy</title>
      </Head>
      <div className="c50 doc-content">
        <div className={css.inner}>
          <p style={{ textAlign: 'center', fontSize: '14px' }}>Version date: 10 Jul 2023</p>
          <p style={{ marginTop: '30px', fontSize: '14px', fontWeight: 'bold' }}>MARKATO HK LIMITED</p>
          <div style={{ borderTop: '2px solid black', marginTop: '20px', width: '300px', marginBottom: '10px' }}></div>
          <p style={{ fontSize: '14px', fontWeight: 'bold' }}>PRIVACY POLICY</p>
          <div style={{ borderTop: '2px solid black', marginTop: '10px', width: '300px' }}></div>
          <p style={{ marginTop: '60px', fontWeight: 'bold' }}>Privacy Policy - Markato Inc</p>
        </div>

        <ol className="c7 lst-kix_list_8-0 start" start={1}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">Objective </span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c12">The purpose of this privacy policy ("</span>
          <span className="c2">Policy</span>
          <span className="c12">
            ") is to outline what we do with your personal data when you visit our website and use our services at
            [www.markato.com] ("
          </span>
          <span className="c2">Markato Platform</span>
          <span className="c0">
            "). It describes how we collect, use, and process your personal data, and how, in doing so, we comply with
            our legal obligations to you. Your privacy is important to us, and we are committed to protecting and
            safeguarding your data privacy rights.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={2}>
          <li className="c1 li-bullet-0">
            <h1 id="h.gjdgxs" style={{ display: 'inline' }}>
              <span className="c15 c2">Scope </span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">This Policy applies to the personal data of users of the Markato Platform, namely:</span>
        </p>
        <ul className="c7 lst-kix_list_9-0 start">
          <li className="c25 li-bullet-1">
            <span className="c0">
              Retailers in Hong Kong or Singapore that use the Markato Platform to buy products from UK or EU-based
              Brands
            </span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">
              Brands in the UK or EU that use the Markato Platform to sell their products to Hong Kong or
              Singapore-based Retailers
            </span>
          </li>
        </ul>
        <p className="c33 c49">
          <span className="c0" />
        </p>
        <p className="c6">
          <span className="c12">
            For the purpose of applicable data protection legislation (including but not limited to the HK PDPO, SG
            PDPA, EU GDPR and UK GDPR), the company which is the data user (under HK PDPO) / organisation (under SG
            PDPA) / controller (under EU GDPR and UK GDPR) and who is responsible for your personal data is Markato HK
            Limited (a company incorporated in Hong Kong (company number 3150358) with its registered office at Unit
            1603, 16th Floor, The L. Plaza, 367 - 375 Queen’s Road Central, Sheung Wan, Hong Kong, and its Affiliates
          </span>
          <span>&nbsp;</span>
          <span className="c12">("</span>
          <span className="c2">Markato</span>
          <span className="c12">" or "</span>
          <span className="c2">us</span>
          <span className="c12">" or "</span>
          <span className="c2">we</span>
          <span className="c0">"). </span>
        </p>
        <p className="c6">
          <span className="c0">
            This Policy describes how we will process your personal data, and satisfies the requirements set out in the
            HK PDPO or SG PDPA (as applicable), if you are an individual that acts on behalf of or is otherwise
            associated with a Retailer based in Hong Kong or Singapore (as applicable) &nbsp;and the collection,
            holding, processing or use of your personal data is controlled by Markato (a Hong Kong based data user or
            Singapore based organisation (as applicable)). On the basis that Brands that use the Markato Platform will
            be based in the European Union or United Kingdom, this Policy also satisfies the requirements set out in the
            EU GDPR and UK GDPR in relation to individuals who act on behalf of or are otherwise associated with Brands
            based within the European Union or United Kingdom (as applicable).
          </span>
        </p>
        <p className="c21">
          <span className="c12">
            This Policy replaces and supersedes any previous policies addressing the same or similar issues, whether
            formal or informal. Markato reserves the right in its absolute discretion to alter, amend, or replace this
            Policy in whole or in part at any time with or without notice. The latest version of this Policy can be
            found here:{' '}
          </span>
          <a href="www.markato.com/privacy-policy">www.markato.com/privacy-policy.</a>
          <span className="c0">
            &nbsp;You should always check that you are referring to the latest version of this Policy if you have
            previously downloaded hard copies of this Policy.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={3}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">Types of personal data collected</span>
            </h1>
          </li>
        </ol>
        <ul className="c7 lst-kix_list_9-0">
          <li className="c25 li-bullet-2">
            <span className="c0">
              All users of the Markato Platform: We collect the following data from you when you use the Markato
              Platform, regardless of whether you are a Retailer or Brand, that we use to help us to improve your
              experience when using the Markato Platform and to help us manage the services we provide.
            </span>
          </li>
          <li className="c25 li-bullet-1">
            <span className="c0">How you use the Markato Platform</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">The frequency with which you access the Markato Platform</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Internet protocol (IP) address</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Operating system and platform</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Your browser type and version</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Time zone setting and location</span>
          </li>
          <li className="c6 c26 li-bullet-2">
            <span className="c12 c29">The language you choose to view the Markato Website in</span>
            <span>&nbsp; &nbsp; &nbsp;</span>
          </li>
        </ul>
        <p className="c6">
          <span className="c12">
            If you would like to find out more information about what data we collect about you when you visit the
            Markato Platform, please see Section 9 (
          </span>
          <span className="c12 c27">Who is responsible for processing your personal data and how to contact us?</span>
          <span className="c0">).</span>
        </p>
        <p className="c6" id="h.30j0zll">
          <span className="c2">Retailer Data</span>
          <span className="c0">
            : We will collect some or all of the information listed below in relation to individuals at your
            organisation to enable us to provide the Markato Platform services to you, to facilitate transactions which
            you make on the Markato Platform and to ensure our relationship runs smoothly.
          </span>
        </p>
        <ul className="c7 lst-kix_list_9-0">
          <li className="c25 li-bullet-2">
            <span className="c0">Name </span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Telephone number</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">
              Organisation details (e.g. place of work, job title and organisation contact information)
            </span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Email</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Postal address</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Payment information</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Marketing preferences</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">
              Information that someone in your organisation has chosen to tell us or that you have chosen to tell
              Markato
            </span>
          </li>
          <li className="c6 c26 li-bullet-2">
            <span className="c12 c29">
              Calls, instant messages and emails with individuals in your organisation may be recorded
            </span>
            <span>&nbsp; &nbsp; &nbsp;</span>
          </li>
        </ul>
        <p className="c6">
          <span className="c0">
            To the extent that you access the Markato Platform, we will also collect certain data from you. If you would
            like more information about this, see the "All users of the Markato Platform" paragraph above.
          </span>
        </p>
        <p className="c6">
          <span className="c2">Brand Data</span>
          <span className="c0">
            : We will collect some or all of the information listed below in relation to individuals at your
            organisation to enable you to supply goods on the Markato Platform, to facilitate transactions made by
            Retailers for your goods on the Markato Platform and to ensure our relationship runs smoothly.
          </span>
        </p>
        <ul className="c7 lst-kix_list_9-0">
          <li className="c25 li-bullet-2">
            <span className="c0">Name </span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Telephone number</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">
              Organisation details (e.g. place of work, job title and organisation contact information)
            </span>
          </li>
          <li className="c25 li-bullet-1">
            <span className="c0">Email</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Postal address</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Bank details</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">Marketing preferences</span>
          </li>
          <li className="c25 li-bullet-2">
            <span className="c0">
              Information that someone in your organisation has chosen to tell us or that you have chosen to tell
              Markato
            </span>
          </li>
          <li className="c6 c26 li-bullet-2">
            <span className="c12 c29">
              Calls, instant messages and emails with individuals in your organisation may be recorded
            </span>
            <span>&nbsp; &nbsp; &nbsp;</span>
          </li>
        </ul>
        <p className="c6">
          <span className="c0">
            To the extent that you access the Markato Platform, we will also collect certain data from you. If you would
            like more information about this, see the "All users of the Markato Platform" paragraph above.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={4}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c2 c15">How your personal data is collected</span>
            </h1>
          </li>
        </ol>
        <ol className="c7 lst-kix_list_8-1 start" start={1}>
          <li className="c11 li-bullet-3">
            <h2 id="h.1fob9te" style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is collected – all users of the Markato Platform</span>
            </h2>
          </li>
        </ol>
        <p className="c19">
          <span className="c0">
            When you visit the Markato Platform there is certain information that we may automatically collect, whether
            or not you decide to use our services. This includes your IP address, the date and the times and frequency
            with which you access the Markato Platform and the way you browse its content.
          </span>
        </p>
        <p className="c6 c37">
          <span className="c12">
            We collect your data automatically via cookies, in line with your cookie settings in your browser. If you
            would like to find out more about cookies, including how we use them and what choices are available to you,
            see Section 11 (
          </span>
          <span className="c12 c27">Cookies</span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={2}>
          <li className="c11 li-bullet-4">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is collected – Retailers</span>
            </h2>
          </li>
        </ol>
        <p className="c19">
          <span className="c0">We collect personal data from Retailers in the following ways:</span>
        </p>
        <ul className="c7 lst-kix_list_5-0 start">
          <li className="c38 c32 li-bullet-1">
            <span className="c0">Personal data that we receive directly from you</span>
          </li>
          <li className="c20 li-bullet-2">
            <span className="c0">Personal data that we receive from other sources</span>
          </li>
          <li className="c10 c32 li-bullet-1">
            <span className="c0">Personal information that we collect automatically</span>
          </li>
        </ul>
        <ol className="c7 lst-kix_list_8-2 start" start={1}>
          <li className="c41 li-bullet-5">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal data that we receive directly from you &nbsp;</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c0">We will receive data directly from you in the following ways:</span>
        </p>
        <ul className="c7 lst-kix_list_5-2 start">
          <li className="c38 c24 li-bullet-2">
            <span className="c0">When you register for an account with us and transact on the Markato Platform</span>
          </li>
          <li className="c24 c48 li-bullet-2">
            <span className="c0">
              Where you contact us proactively by phone or email or any other form of communication (including where you
              request direct marketing communications be sent to you)
            </span>
          </li>
          <li className="c10 c24 li-bullet-2">
            <span className="c12 c29">Where we contact you, whether by phone, by email, or by any other</span>
            <span>&nbsp; &nbsp; &nbsp;</span>
            <span className="c0">&nbsp;form of communication</span>
          </li>
        </ul>
        <a id="id.3znysh7" />
        <ol className="c7 lst-kix_list_8-2" start={2}>
          <li className="c41 li-bullet-6">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal Data We Receive from Other Sources</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c0">
            Where appropriate and in accordance with any local laws and requirements, we may seek more information about
            you from other sources including surveys, web search, customer lists, social media etc.
          </span>
        </p>
        <a id="id.2et92p0" />
        <ol className="c7 lst-kix_list_8-2" start={3}>
          <li className="c41 li-bullet-7">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal Data Collected Automatically</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c12">
            To the extent that you access the Markato Platform, read, or click on an email from us, where appropriate
            and in accordance with any local laws and requirements, we may collect your data automatically or through
            you providing it to us. For more information please see Section 4.1 (
          </span>
          <span className="c12 c27">How your personal data is collected – all users of the Markato Platform</span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={3}>
          <li className="c11 li-bullet-3">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is collected – Brands</span>
            </h2>
          </li>
        </ol>
        <p className="c19">
          <span className="c0">We collect personal data from Brands in the following ways:</span>
        </p>
        <ul className="c7 lst-kix_list_5-0">
          <li className="c38 c32 li-bullet-2">
            <span className="c0">Personal data that we receive directly from you</span>
          </li>
          <li className="c20 li-bullet-2">
            <span className="c0">Personal data that we receive from other sources</span>
          </li>
          <li className="c10 c32 li-bullet-2">
            <span className="c0">Personal information that we collect automatically</span>
          </li>
        </ul>
        <ol className="c7 lst-kix_list_8-2 start" start={1}>
          <li className="c41 li-bullet-5">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal data that we receive directly from you &nbsp;</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c0">We will receive data directly from you in the following ways:</span>
        </p>
        <ul className="c7 lst-kix_list_5-2">
          <li className="c24 c38 li-bullet-1">
            <span className="c0">When you register for an account with us and transact on the Markato Platform</span>
          </li>
          <li className="c48 c24 li-bullet-2">
            <span className="c0">
              Where you contact us proactively by phone or email or any other form of communication (including where you
              request direct marketing communications be sent to you)
            </span>
          </li>
          <li className="c10 c24 li-bullet-1">
            <span className="c12 c29">Where we contact you, whether by phone, by email, or by any other</span>
            <span>&nbsp; &nbsp; &nbsp;</span>
            <span className="c0">&nbsp;form of communication</span>
          </li>
        </ul>
        <ol className="c7 lst-kix_list_8-2" start={2}>
          <li className="c41 li-bullet-6">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal Data We Receive from Other Sources</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c0">
            Where appropriate and in accordance with any local laws and requirements, we may seek more information about
            you from other sources including surveys, web search, customer lists, social media etc.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-2" start={3}>
          <li className="c41 li-bullet-6">
            <h3 style={{ display: 'inline' }}>
              <span className="c15 c2">Personal Data Collected Automatically</span>
            </h3>
          </li>
        </ol>
        <p className="c6 c13">
          <span className="c12">
            To the extent that you access the Markato Platform, read, or click on an email from us, where appropriate
            and in accordance with any local laws and requirements, we may collect your data automatically or through
            you providing it to us. For more information please see Section 4.1 (
          </span>
          <span className="c12 c27">How your personal data is collected – all users of the Markato Platform</span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={5}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is used</span>
            </h1>
          </li>
        </ol>
        <ol className="c7 lst-kix_list_8-1 start" start={1}>
          <li className="c11 li-bullet-3">
            <h2 id="h.tyjcwt" style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is used – all users of the Markato Platform</span>
            </h2>
          </li>
        </ol>
        <p className="c6 c37">
          <span className="c12">
            We use your data to help us to improve your experience of using our website. If you would like to find out
            more about cookies, including how we use them and what choices are available to you, see Section 11 (
          </span>
          <span className="c12 c27">Cookies</span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={2}>
          <li className="c11 li-bullet-8">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is used – Retailers</span>
            </h2>
          </li>
        </ol>
        <p className="c19">
          <span className="c0">Having obtained data about you, we then make sure we use it appropriately.</span>
        </p>
        <p className="c19">
          <span className="c0">
            We collect, use, disclose and/or process your personal data for the following purposes:
          </span>
        </p>
        <ul className="c7 lst-kix_list_5-0">
          <li className="c38 c32 li-bullet-2">
            <span className="c0">To manage your account</span>
          </li>
          <li className="c20 li-bullet-2">
            <span className="c0">
              To facilitate transactions which you make on the Markato Platform and to comply with our obligations to
              you
            </span>
          </li>
          <li className="c20 li-bullet-1">
            <span className="c12 c29">To send you direct marketing communications</span>
          </li>
          <li className="c10 c32 li-bullet-2">
            <span className="c0">To help us establish, exercise, or defend legal claims</span>
          </li>
        </ul>
        <p className="c19">
          <span className="c12">
            We intend to use your name, telephone number, email address and postal address for direct marketing such as
            notifications, communications and recommendations of products which may be relevant to you but we cannot so
            use your personal data without your consent. Please tick the separate consent checkbox for marketing to
            indicate your agreement to such use.
          </span>
        </p>
        <p className="c19" id="h.3dy6vkm">
          <span className="c12">Please also see Section 5.1 (</span>
          <span className="c12 c27">How your personal data is used – all users of the Markato Platform</span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={3}>
          <li className="c11 li-bullet-9">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How your personal data is used – Brands</span>
            </h2>
          </li>
        </ol>
        <p className="c19">
          <span className="c0">Having obtained data about you, we then make sure we use it appropriately.</span>
        </p>
        <p className="c19">
          <span className="c0">
            We collect, use, disclose and/or process your personal data for the following purposes:
          </span>
        </p>
        <ul className="c7 lst-kix_list_5-0">
          <li className="c38 c32 li-bullet-2">
            <span className="c0">To manage your account</span>
          </li>
          <li className="c20 li-bullet-2">
            <span className="c0">
              To facilitate transactions made with you on the Markato Platform and to comply with our obligations to you
            </span>
          </li>
          <li className="c20 li-bullet-2">
            <span className="c0">To send you direct marketing communications</span>
          </li>
          <li className="c10 c32 li-bullet-2">
            <span className="c0">To help us establish, exercise, or defend legal claims</span>
          </li>
        </ul>
        <p className="c19">
          <span className="c12">
            We intend to use your name, telephone number, email address and postal address for direct marketing such as
            notifications, communications and recommendations of products which may be relevant to you but we cannot so
            use your personal data without your consent. Please tick the separate consent checkbox for marketing to
            indicate your agreement to such use.
          </span>
        </p>
        <p className="c19">
          <span className="c12">Under the</span>
          <span className="c0">
            &nbsp;EU GDPR and UK GDPR (which applies to our processing of personal data relating to Brands in the UK or
            EU), we are required to provide additional information about how we use your personal data. This is set out
            in the table below:
          </span>
        </p>
        <a id="t.996113e35356cfe1bcaafbe6209ce490a601d9db" />
        <a id="t.0" />
        <table className="c40">
          <tbody>
            <tr className="c17">
              <td className="c39 c44" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c15 c2">Why and how we process your information</span>
                </p>
              </td>
              <td className="c35 c44" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c15 c2">Types of personal data used</span>
                </p>
              </td>
              <td className="c31" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c15 c2">Legal basis relied upon under EU GDPR, UK GDPR</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c47" colSpan={3} rowSpan={1}>
                <p className="c10">
                  <span className="c0">To manage your account</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Processing your data to maintain and support your account</span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0 start">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-10">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">Postal address</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Bank details</span>
                  </li>
                </ul>
                <p className="c10 c33">
                  <span className="c0" />
                </p>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Legitimate interests, namely it is in our interests:</span>
                </p>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">to maintain our account holder details;</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to service your account and communicate with you;</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to ensure our business runs smoothly;</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">to safeguard our business interests; and</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to verify the people we deal with.</span>
                  </li>
                </ul>
                <p className="c10">
                  <span className="c0">We may also need to process your data to comply with our legal obligations</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c47" colSpan={3} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    To facilitate transactions made with you on the Markato Platform and to comply with our obligations
                    to you
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Processing your data in accordance with our legal obligations and/or internal processes or
                    processing your data to comply with any of our other legal obligations.
                  </span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-10">
                    <span className="c0">Postal address</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Bank details</span>
                  </li>
                </ul>
                <p className="c10 c33">
                  <span className="c0" />
                </p>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Legitimate interests, namely it is in our interests:</span>
                </p>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">to ensure compliance with company policies;</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to safeguard our business interests; and</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to verify the people we deal with.</span>
                  </li>
                </ul>
                <p className="c10">
                  <span className="c0">We may also need to process your data to comply with our legal obligations</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Processing your data in order to facilitate transactions made with you and fulfil any requests.
                  </span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-10">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Postal address</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Bank details</span>
                  </li>
                </ul>
                <p className="c10 c33">
                  <span className="c0" />
                </p>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Legitimate interests, namely it is in our interests and your interests for us to provide our
                    services to you or answer any queries.
                  </span>
                </p>
                <p className="c10 c33">
                  <span className="c0" />
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Storing your details (and updating them when necessary) on our database, so that we can contact you
                    in relation to our relevant activities.
                  </span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Postal address</span>
                  </li>
                </ul>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Legitimate interests, namely it is in our interests and your interests:</span>
                </p>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">
                      to ensure we have an accurate record of all of our suppliers that we interact with; and
                    </span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to ensure our business runs smoothly.</span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Reviewing, verifying, and keeping records of our conversations, meetings, and transactions for the
                    purpose of our internal processes and, so that we can provide targeted services to you and in order
                    to comply with our legal obligations.
                  </span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">
                      information that you have chosen to tell us or that you have chosen to tell a Markato staff member
                      (e.g. during a call)
                    </span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">calls, instant messages and emails with you</span>
                  </li>
                </ul>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Legitimate interests, namely it is in our interests and your interests:</span>
                </p>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">to ensure we provide you with relevant information in the future; and</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">to ensure our business runs smoothly.</span>
                  </li>
                </ul>
                <p className="c10">
                  <span className="c0">
                    We may also need to process your personal data to comply with our legal obligations
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">Getting your feedback.</span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Job title</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">Email</span>
                  </li>
                </ul>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Legitimate interests, namely it is in our interests to improve and develop our offering by
                    considering your feedback and feeding this into our processes where we deem necessary
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c47" colSpan={3} rowSpan={1}>
                <p className="c10">
                  <span className="c0">To send you direct marketing communications</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">To send you direct marketing communications</span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Postal address</span>
                  </li>
                </ul>
                <p className="c10 c33">
                  <span className="c0" />
                </p>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">We send you marketing emails in reliance on your consent.</span>
                </p>
                <p className="c10">
                  <span className="c0">
                    Where permitted by applicable law and unless you have opted-out, we may also send marketing
                    communications based on our legitimate interests, namely it is in our interests to send you
                    marketing communications where you are an existing supplier who may be interested in our Markato
                    Platform services/features to provide you with further opportunities to sell your goods.
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c47" colSpan={3} rowSpan={1}>
                <p className="c10">
                  <span className="c0">To help us establish, exercise, or defend legal claims</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c39" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">To help us to establish, exercise, or defend legal claims.</span>
                </p>
              </td>
              <td className="c35" colSpan={1} rowSpan={1}>
                <ul className="c7 lst-kix_list_10-0">
                  <li className="c5 li-bullet-2">
                    <span className="c0">Name</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">Telephone number</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Email</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Postal address</span>
                  </li>
                  <li className="c5 li-bullet-1">
                    <span className="c0">Bank details</span>
                  </li>
                  <li className="c5 li-bullet-10">
                    <span className="c0">Calls, instant messages and emails with you</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Automatically collected information</span>
                  </li>
                  <li className="c5 li-bullet-2">
                    <span className="c0">Information that others provide about you</span>
                  </li>
                  <li className="c5 li-bullet-10">
                    <span className="c0">Additional information that you choose to tell us</span>
                  </li>
                </ul>
              </td>
              <td className="c34" colSpan={1} rowSpan={1}>
                <p className="c10">
                  <span className="c0">
                    Legitimate interests, namely it is in our interests for us to be enabled to establish and defend our
                    legal rights and understand our obligations, and seek legal advice in connection with them.
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="c10 c33">
          <span className="c0" />
        </p>
        <p className="c19">
          <span className="c12">Please also see Section 5.1 (</span>
          <span className="c12 c27">How your personal data is used – all users of the Markato Platform</span>
          <span className="c0">).</span>
        </p>
        <a id="id.17dp8vu" />
        <ol className="c7 lst-kix_list_8-0" start={6}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">How do we share your personal data?</span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">
            Where appropriate and in accordance with local laws and requirements, we may share your personal data, in
            various ways and for various reasons, with the following categories of people:
          </span>
        </p>
        <ul className="c7 lst-kix_list_7-0 start">
          <li className="c4 li-bullet-2">
            <span className="c0">any of our group companies;</span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              tax, audit, regulatory bodies, or other authorities, when we believe in good faith that the law or other
              regulation requires us to share this data (e.g., because of a request by a tax authority, in connection
              with any anticipated litigation or in compliance with our legal obligations);
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              third party service providers (including suppliers) who perform functions on our behalf (including
              administrators, external consultants, business associates, and professional advisers such as lawyers,
              auditors and accountants, transport and distribution suppliers, technical support functions, and IT
              consultants carrying out testing and development work on our business technology systems);
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              third party outsourced IT and document storage providers where we have an appropriate processing agreement
              (or similar protections) in place; and
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              if Markato merges with or is acquired by another business or company in the future, we may share your
              personal data with the new or prospective owners of the business or company as part of the merger or
              acquisition process (and may provide you with notice of this disclosure).
            </span>
          </li>
        </ul>
        <a id="id.3rdcrjn" />
        <ol className="c7 lst-kix_list_8-0" start={7}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">How do we safeguard your personal data?</span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">
            We are committed to taking all reasonable and appropriate steps to protect the personal data that we hold
            from misuse, loss, or unauthorised access. We do this by having in place a range of appropriate technical
            and organisational measures. These include measures to deal with any suspected data breach.
          </span>
        </p>
        <p className="c6">
          <span className="c12">
            If you suspect any misuse, loss of, or unauthorised access to your personal data, please let us know
            immediately. Details of how to contact us can be found in Section 2 (
          </span>
          <span className="c12 c27">Scope</span>
          <span className="c0">).</span>
        </p>
        <a id="id.26in1rg" />
        <ol className="c7 lst-kix_list_8-0" start={8}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">How long do we keep your personal data?</span>
            </h1>
          </li>
        </ol>
        <p className="c18">
          <span className="c0">
            We will ordinarily process your data throughout the course of our interactions and will then generally
            retain it for an appropriate amount of time afterwards. The precise length of time will depend on the type
            of data, our legitimate business needs, and other legal requirements that may require us to retain it for
            certain minimum periods.
          </span>
        </p>
        <p className="c18">
          <span className="c0">
            We may be required to retain certain data for the purposes of tax reporting or responding to tax queries. In
            other instances, there may be some other legal or risk management requirements to retain data, including
            where certain data might be relevant to any potential litigation (bearing in mind relevant limitation
            periods).
          </span>
        </p>
        <p className="c18">
          <span className="c0">
            In determining the appropriate retention period for different types of personal data, we always consider the
            amount, nature, and sensitivity of the personal data in question, the potential risk of harm from
            unauthorised use or disclosure of that personal data, the purposes for which we need to process it and
            whether we can achieve those purposes by other means (in addition of course to ensuring that we comply with
            our legal and risk management obligations, as described above).
          </span>
        </p>
        <p className="c18">
          <span className="c0">
            Once we have determined that we no longer need to hold your personal data, we will delete it from our
            systems.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={9}>
          <li className="c1 li-bullet-0">
            <h1 id="h.lnxbz9" style={{ display: 'inline' }}>
              <span className="c15 c2">Who is responsible for processing your personal data and how to contact us</span>
            </h1>
          </li>
        </ol>
        <p className="c18">
          <span className="c12 c29">
            The controller and company responsible for compliance with this Policy is Markato HK Limited (a company
            incorporated in Hong Kong (company number 3150358) with its registered office at Unit 1603, 16th Floor, The
            L. Plaza, 367 - 375 Queen’s Road Central, Sheung Wan, Hong Kong, and its Affiliates
          </span>
          <span>&nbsp; &nbsp; &nbsp;</span>
          <span className="c0">. </span>
        </p>
        <p className="c18">
          <span className="c12 c29">
            If you would like further information about how we handle your personal information, if you have any
            concerns regarding this Policy, or if you wish to exercise your legal rights as set out in section 12 (
          </span>
          <span className="c12 c27 c29">
            How can you access, amend, or take back the personal data that you have given to us?
          </span>
          <span className="c0">
            ), please write to support@markato.com addressed to Martin Li, Co-founder at physical address Unit 1603,
            16th Floor, The L. Plaza, 367 - 375 Queen’s Road Central, Sheung Wan, Hong Kong
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={10}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">How do we store and transfer your data internationally?</span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">
            In order to provide you with the best service and to carry out the purposes described in this Policy, your
            data may be transferred:
          </span>
        </p>
        <ul className="c7 lst-kix_list_2-1 start">
          <li className="c21 c43 li-bullet-11">
            <span className="c0">between and within entities within our group, including overseas;</span>
          </li>
          <li className="c21 c43 li-bullet-12">
            <span className="c0">to third parties (such as advisers or other suppliers to the Markato business);</span>
          </li>
          <li className="c21 c43 li-bullet-13">
            <span className="c0">to a cloud-based storage provider.</span>
          </li>
        </ul>
        <p className="c6">
          <span className="c12">To other third parties, as referred in Section 6 (</span>
          <span className="c12 c27">How do we share your personal data?</span>
          <span className="c0">)</span>
        </p>
        <p className="c6">
          <span className="c12">Please see Section 12 (</span>
          <span className="c12 c27">
            How can you access, amend, or take back the personal data that you have given to us?
          </span>
          <span className="c0">) for more information on how we transfer your data internationally.</span>
        </p>
        <p className="c6">
          <span className="c0">
            To ensure that your personal information receives an adequate level of protection, we have put in place
            appropriate procedures with the third parties we share your personal data with to ensure that your personal
            information is treated by those third parties in a way that is consistent with and which respects the law on
            data protection.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-0" start={11}>
          <li className="c1 li-bullet-0">
            <h1 id="h.35nkun2" style={{ display: 'inline' }}>
              <span className="c15 c2">Cookies</span>
            </h1>
          </li>
        </ol>
        <ol className="c7 lst-kix_list_8-1 start" start={1}>
          <li className="c14 li-bullet-14">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">Cookie Definition</span>
            </h2>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">
            When you first visit the Markato Platform, you will be presented with a pop-up screen informing you of our
            use of cookies and asking you to provide your consent for such use.
          </span>
        </p>
        <p className="c6">
          <span className="c12">
            The pop-up screen may not reappear for all your subsequent visits to the Markato Platform, but if you wish,
            you can withdraw your consent at any time by changing the cookie settings in your browser to block or reject
            certain cookies, delete existing ones, or change them.
          </span>
        </p>
        <p className="c6">
          <span className="c0">
            A "cookie" is a piece of information that is stored on your computer's hard drive which records your
            navigation of a website so that, when you revisit that website, it can present tailored options based on the
            information stored about your last visit. Cookies can also be used to analyse traffic and for advertising
            and marketing purposes.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={2}>
          <li className="c14 li-bullet-15">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How Cookies are used</span>
            </h2>
          </li>
        </ol>
        <p className="c6">
          <span className="c12">
            We use cookies to track your use of the Markato Platform. This enables us to understand how you use the site
            and track any patterns that emerge individually or from larger groups. This helps us to develop and improve
            the Markato Platform
          </span>
          <span className="c2">&nbsp;</span>
          <span className="c0">and our services in response to what our users want and need.</span>
        </p>
        <p className="c6">
          <span className="c0">Cookies are either:</span>
        </p>
        <ul className="c7 lst-kix_list_4-0 start">
          <li className="c4 li-bullet-1">
            <span className="c2 c29">Session cookies</span>
            <span className="c0">
              : these are only stored on your computer [or device] during your web session and are automatically deleted
              when you close your browser - they usually store an anonymous session ID allowing you to browse a website
              without having to log in to each page but they do not collect any information from your computer.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c2 c29">Persistent cookies</span>
            <span className="c0">
              : is stored as a file on your computer [or device] and it remains there when you close your web browser.
              The cookie is read by the website that created it when you visit that website again. We use persistent
              cookies for Google Analytics and for personalisation (see below).
            </span>
          </li>
        </ul>
        <p className="c6">
          <span className="c0">Cookies are also categorised as follows:</span>
        </p>
        <ul className="c7 lst-kix_list_6-0 start">
          <li className="c4 li-bullet-2">
            <span className="c2 c29">Strictly necessary cookies</span>
            <span className="c0">
              : Essential to enable you to use the Markato Platform effectively and therefore cannot be turned off.
              Without these cookies, the services available to you on the Markato Platform cannot be provided. These
              cookies do not gather information about you that could be used for marketing or remembering where you have
              been on the internet.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c2 c29">Performance cookies</span>
            <span className="c0">
              : These cookies enable us to monitor and improve the performance of the Markato Platform. For example,
              they allow us to count visits, identify traffic sources, and see which parts of the platform are most
              popular.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c2 c29">Functionality cookies</span>
            <span className="c0">
              : These cookies allow the Markato Platform to remember choices you make (such as your language or the
              region you are in) and provide enhanced features. They may also be used to provide services you have
              requested. The information these cookies collect is usually anonymised.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c2 c29">Personalisation cookies</span>
            <span className="c0">
              : These cookies help us to provide users with a tailored experience. These cookies are persistent (for as
              long as you are registered with us) and mean that when you log in or return to the Markato Platform, you
              may see contextual advertisements that are similar to content that you have previously browsed.
            </span>
          </li>
        </ul>
        <a id="id.44sinio" />
        <ol className="c7 lst-kix_list_8-0" start={12}>
          <li className="c1 li-bullet-0">
            <h1 id="h.1ksv4uv" style={{ display: 'inline' }}>
              <span className="c15 c2">
                How can you access, amend or take back the personal data that you have given to us?
              </span>
            </h1>
          </li>
        </ol>
        <p className="c6">
          <span className="c0">
            The EU GDPR and UK GDPR offer various protections and clarify the rights of citizens and individuals in the
            European Union or the United Kingdom, with regard to data privacy. This means that you retain various rights
            in respect of your data, even once you have given it to us. These are described in more detail below.
          </span>
        </p>
        <p className="c6">
          <span className="c12">
            To communicate about these rights, please contact us (with the details given at Section 9 (
          </span>
          <span className="c12 c27">Who is responsible for processing your personal data and how to contact us</span>
          <span className="c0">
            ). We will seek to deal with your request without undue delay within one month (subject to any extensions to
            which we are lawfully entitled).
          </span>
        </p>
        <p className="c6">
          <span className="c0">
            Under HK PDPO and SG PDPA, data subject rights are limited to the rights to request access to and to request
            the correction of personal data. &nbsp;If you have provided us with your consent to use your personal data,
            you can also withdraw your consent at anytime under HK PDPO and/or SG PDPA.
          </span>
        </p>
        <p className="c21">
          <span className="c2">NOTE:</span>
          <span className="c0">
            &nbsp;We may keep a record of your communications to help us resolve any issues that you raise.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right to object (not available under HK PDPO and SG PDPA): </span>
          <span className="c0">
            This enables you to object to us processing your personal data. This is possible for one of the following
            four reasons: (i) our legitimate interests; (ii) to enable us to perform a task in the public interest or
            exercise official authority; (iii) to send you direct marketing materials (in both Hong Kong and Singapore,
            you have the right to withdraw your consent to marketing at any time); and (iv) for scientific, historical,
            research, or statistical purposes.
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            The "legitimate interests" category above is most likely to apply. If your objection relates to us
            processing your personal data because we deem it necessary for your legitimate interests, we must act on
            your objection by ceasing the activity in question unless:
          </span>
        </p>
        <ul className="c7 lst-kix_list_3-0 start">
          <li className="c4 li-bullet-2">
            <span className="c0">
              We can show that we have compelling legitimate grounds for processing which overrides your interests.
            </span>
          </li>
          <li className="c4 li-bullet-1">
            <span className="c0">
              We are processing your data for the establishment, exercise, or defence of a legal claim.
            </span>
          </li>
        </ul>
        <p className="c21">
          <span className="c2">Right to withdraw consent: </span>
          <span className="c0">
            We have obtained your consent to process your personal data. You may withdraw this consent at any time and
            we will cease to carry out the particular activity that you previously consented to unless we consider that
            there is an alternative reason to justify our continued processing of your data for this purpose. In which
            case, we will inform you of this condition.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right to access: </span>
          <span className="c0">
            You may ask us to confirm what information we hold about you at any time, and request us to modify, update,
            or delete such information. We may ask you to verify your identity and for more information about your
            request. If we provide you with access to the information that we hold about you, we will not charge you for
            this unless your request is "manifestly unfounded or excessive." If you request further copies of this
            information from us, we may charge you a reasonable administrative cost where legally permissible. Where we
            are legally permitted to do so, we may refuse your request. If we refuse your request, we will always tell
            you the reasons for doing so.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right to erasure (not available under HK PDPO and SG PDPA): </span>
          <span className="c0">
            You have the right to request that we erase your personal data in certain circumstances. Normally, the
            information must meet one of the following criteria:
          </span>
        </p>
        <ul className="c7 lst-kix_list_3-0">
          <li className="c4 li-bullet-2">
            <span className="c0">
              the data is no longer necessary for the purpose for which we originally collected and/or processed them;
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              where previously given, you have withdrawn your consent to us processing your data, and there is no other
              valid reason for us to continue processing;
            </span>
          </li>
          <li className="c4 li-bullet-10">
            <span className="c0">
              the data has been processed unlawfully (i.e., in a manner which does not comply with the EU GDPR and UK
              GDPR);
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              it is necessary for the data to be erased in order for us to comply with our legal obligations as a data
              controller; or
            </span>
          </li>
          <li className="c4 li-bullet-1">
            <span className="c0">
              if we process the data because we believe it necessary to do so for our legitimate interests, you object
              to the processing and we are unable to demonstrate overriding legitimate grounds for our continued
              processing.
            </span>
          </li>
        </ul>
        <p className="c21">
          <span className="c0">
            We would only be entitled to refuse to comply with your request for erasure for one of the following
            reasons:
          </span>
        </p>
        <ul className="c7 lst-kix_list_3-0">
          <li className="c4 li-bullet-2">
            <span className="c0">to exercise the right of freedom of expression and information;</span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              to comply with legal obligations or for the performance of a public interest task or exercise of official
              authority;
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">for public health reasons in the public interest;</span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">for archival, research, or statistical purposes; or</span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">to exercise or defend a legal claim.</span>
          </li>
        </ul>
        <p className="c21">
          <span className="c0">
            When complying with a valid request for the erasure of data we will take all reasonably practicable steps to
            delete the relevant data.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right to restrict processing (not available under HK PDPO and SG PDPA): </span>
          <span className="c0">
            You have the right to request that we restrict our processing of your personal data in certain
            circumstances. We can only continue to store your data, and will not be able to carry out any further
            processing activities with it until either: (i) one of the circumstances listed below is resolved; (ii) you
            consent; or (iii) further processing is necessary for either the establishment, exercise, or defence of
            legal claims, the protection of the rights of another individual, or reasons of important EU or UK public
            interest.
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            The circumstances in which you are entitled to request that we restrict the processing of your personal data
            include the following:
          </span>
        </p>
        <ul className="c7 lst-kix_list_3-0">
          <li className="c4 li-bullet-2">
            <span className="c0">
              where you dispute the accuracy of the personal data that we are processing about you. In this case, our
              processing of your personal data will be restricted for the period during which the accuracy of the data
              is verified;
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              where you object to our processing of your personal data for our legitimate interests. Here, you can
              request that the data be restricted while we verify our grounds for processing your personal data;
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              where our processing of your data is unlawful, but you would prefer us to restrict our processing of it
              rather than erasing it; and
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              where we have no further need to process your personal data but you require the data to establish,
              exercise, or defend legal claims.
            </span>
          </li>
        </ul>
        <p className="c21">
          <span className="c0">
            If we have shared your personal data with third parties, we will notify them about the restricted processing
            unless this is impossible or involves disproportionate effort. We will notify you before lifting any
            restriction on processing your personal data.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right to rectification: </span>
          <span className="c0">
            You also have the right to request that we rectify any inaccurate or incomplete personal data that we hold
            about you. If we have shared this personal data with third parties, we will notify them about the
            rectification unless this is impossible or involves disproportionate effort. Where appropriate, we will also
            tell you which third parties we have disclosed the inaccurate or incomplete personal data. Where we think
            that it is reasonable for us not to comply with your request, we will explain our reasons for this decision.
          </span>
        </p>
        <p className="c21">
          <span className="c2">Right of data portability (not available under HK PDPO and SG PDPA): </span>
          <span className="c0">
            If you wish, you have the right to transfer your personal data between data controllers. If applicable, this
            means that you are able to transfer any Markato account details to another provider. To allow you to do so,
            we will provide you with your data in a commonly used machine-readable format that is password-protected so
            that you can transfer the data to another provider. Alternatively, we may directly transfer the data for
            you. This right of data portability applies to: (i) personal data that we process automatically (i.e.,
            without any human intervention); (ii) personal data provided by you; and (iii) personal data that we process
            based on your consent or in order to fulfil a contract.
          </span>
        </p>
        <p className="c21">
          <span className="c15 c2">Right to lodge a complaint with a supervisory authority:</span>
        </p>
        <p className="c21">
          <span className="c12">
            If you are in the EU or UK, you also have the right to lodge a complaint with your local supervisory
            authority. The supervisory authority in the United Kingdom is the Information Commissioner's Office at:
            Information Commissioner's Office, Wycliffe House, Water Lane, Wilmslow, Cheshire, SK9 5AF (T: 0303 123 1113
            E:{' '}
          </span>
          <span className="c23 c12">
            <a className="c42" href="mailto:icocasework@ico.org.uk">
              icocasework@ico.org.uk
            </a>
          </span>
          <span className="c12">
            ). The supervisory authorities for EU Member States are listed (along with contact details){' '}
          </span>
          <span className="c12 c23">
            <a
              className="c42"
              href="https://www.google.com/url?q=http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm.&sa=D&source=editors&ust=1688986106618133&usg=AOvVaw1S785UuSFXIYvVOsOOcJTc"
            >
              here
            </a>
          </span>
          <span className="c0">.</span>
        </p>
        <p className="c21">
          <span className="c12">
            If you would like to exercise any of these rights, or withdraw your consent to the processing of your
            personal data (where consent is our legal basis for processing your personal data), for details on how to
            contact us, see Section 9 (
          </span>
          <span className="c12 c27">Who is responsible for processing your personal data and how to contact us</span>
          <span className="c0">).</span>
        </p>
        <p className="c21">
          <span className="c2">NOTE: </span>
          <span className="c0">
            We may keep a record of your communications to help us resolve any issues that you raise.
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            It is important that the personal information we hold about you is accurate and current. Please keep us
            informed if your personal information changes during the period for which we hold your data.
          </span>
        </p>
        <a id="id.2jxsxqh" />
        <ol className="c7 lst-kix_list_8-0" start={13}>
          <li className="c1 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c15 c2">
                Legal Bases for Processing Your Data (This section is applicable to EU GDPR and UK GDPR only)
              </span>
            </h1>
          </li>
        </ol>
        <p className="c21">
          <span className="c0">The legal bases that we rely on to process your personal data are listed below.</span>
        </p>
        <a id="id.z337ya" />
        <ol className="c7 lst-kix_list_8-1" start={3}>
          <li className="c14 li-bullet-16">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">Legitimate Interests</span>
            </h2>
          </li>
        </ol>
        <p className="c21">
          <span className="c0">
            Article 6(1)(f) of the EU GDPR (and equivalent provisions under UK GDPR) says that we can process your data
            where it "is necessary for the purposes of the legitimate interests pursued by [us] or by a third party,
            except where such interests are overridden by the interests or fundamental rights or freedoms of [you] which
            require protection of personal data."
          </span>
        </p>
        <p className="c21">
          <span className="c12">
            You have the right to object to us processing your personal data on this basis. If you would like to know
            more about how to do so, see Section 12 (
          </span>
          <span className="c12 c27">
            How can you access, amend, or take back the personal data that you have given to us?
          </span>
          <span className="c0">).</span>
        </p>
        <p className="c21">
          <span className="c0">
            We use and store your personal data in order to ensure you can use the Markato Platform smoothly and so as
            to respond to you if you contact us through the Markato Platform.
          </span>
        </p>
        <a id="id.3j2qqm3" />
        <ol className="c7 lst-kix_list_8-1" start={4}>
          <li className="c14 li-bullet-3">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">Consent</span>
            </h2>
          </li>
        </ol>
        <p className="c21">
          <span className="c0">
            In certain circumstances, we are required to obtain your consent to the processing of your personal data in
            relation to certain activities.
          </span>
        </p>
        <p className="c21">
          <span className="c12">Article 4(11) of the EU GDPR states that (opt-in) consent is </span>
          <span className="c12 c27">
            "any freely given, specific, informed and unambiguous indication of the data subject's wishes by which he or
            she, by a statement or by a clear affirmative action, signifies agreement to the processing of personal data
            relating to him or her"
          </span>
          <span className="c0">&nbsp;In plain language, this means that:</span>
        </p>
        <ul className="c7 lst-kix_list_3-0">
          <li className="c4 li-bullet-2">
            <span className="c0">
              You have to give us your consent freely, without us putting you under any type of pressure.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              You have to know what you are consenting to so we will make sure we give you enough information.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              You should have control over which processing activities you consent to and which you do not.
            </span>
          </li>
          <li className="c4 li-bullet-1">
            <span className="c0">
              You need to take positive and affirmative action in giving us your consent. We are likely to provide a
              check box for you to check so that this requirement is met in a clear and unambiguous fashion.
            </span>
          </li>
          <li className="c4 li-bullet-1">
            <span className="c0">We will keep records of the consents that you have given in this way.</span>
          </li>
        </ul>
        <p className="c21">
          <span className="c12">
            You have the right to withdraw your consent to these activities. You can do so at any time. See Section 12 (
          </span>
          <span className="c12 c27">
            How can you access, amend, or take back the personal data that you have given to us?
          </span>
          <span className="c0">).</span>
        </p>
        <a id="id.1y810tw" />
        <ol className="c7 lst-kix_list_8-1" start={5}>
          <li className="c14 li-bullet-14">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">For the Performance of a Contract</span>
            </h2>
          </li>
        </ol>
        <p className="c21">
          <span className="c0">
            In certain circumstances we may use and process your personal information where it is necessary to perform a
            contract that you have with us. For example, when you purchase any products on the Markato Platform, we need
            to use your personal information to process your order, to send you the product, for billing purposes and to
            respond to any requests you may have.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={6}>
          <li className="c14 li-bullet-4">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">Compliance with a Legal Obligation</span>
            </h2>
          </li>
        </ol>
        <p className="c21">
          <span className="c12">
            We also have legal obligations that we must comply with. Article (6)(1)(c) of the EU GDPR (and equivalent
            provisions under UK GDPR) states that we can process your personal data where this processing{' '}
          </span>
          <span className="c12 c27">"is necessary for compliance with a legal obligation to which</span>
          <span className="c12">&nbsp;[we] </span>
          <span className="c12 c27">are subject."</span>
        </p>
        <p className="c21">
          <span className="c0">
            We will process your data where we are required to comply with our legal obligations. If we believe in good
            faith that it is necessary, we may share your data in connection with crime detection or tax collection.
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            We also may share your data with other relevant bodies in order to comply with any regulatory obligations.
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            We will keep records of your personal data (including personal data contained in communications and calls)
            in accordance with our legal obligations.
          </span>
        </p>
        <p className="c21">
          <span className="c12">
            In this Policy we refer to data being processed or disclosed in connection with a legal obligation. It is
            not possible to provide a comprehensive and exhaustive list of the legal obligations that may give rise to
            such requirements. New laws may be enacted or other obligations become binding which may require processing
            your data in accordance with other legal obligations. However, examples include processing in order to
            comply with court orders, regulatory rules or directions, or applicable legislation. &nbsp;
          </span>
          <span className="c12">
            Legislation which would require us to process your personal data includes legislation pertaining to
            corporate obligations, anti-money laundering and tax and accounting. &nbsp;
          </span>
          <span className="c0">&nbsp;</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={7}>
          <li className="c14 li-bullet-16">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">Establish, Exercise, or Defend Legal Claims</span>
            </h2>
          </li>
        </ol>
        <p className="c21">
          <span className="c12">
            Sometimes it may be necessary for us to process personal data and, where appropriate and in accordance with
            local laws and requirements, special categories of personal data in connection with exercising or defending
            legal claims. Article 9(2)(f) of the EU GDPR (and equivalent provisions under UK GDPR) allows this where the
            processing{' '}
          </span>
          <span className="c12 c27">
            "is necessary for the establishment, exercise, or defence of legal claims or whenever courts are acting in
            their judicial capacity."
          </span>
        </p>
        <p className="c21">
          <span className="c0">
            This may arise for example where we need to take legal advice in relation to legal proceedings or are
            required by law to preserve or disclose certain information as part of the legal process.
          </span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={8}>
          <li className="c14 li-bullet-9">
            <h2 style={{ display: 'inline' }}>
              <span className="c29 c46">Special Categories of Personal Data</span>
            </h2>
          </li>
        </ol>
        <p className="c18">
          <span className="c0">
            In certain cases, we may process information about your ethnic background, gender, disability, age, sexual
            orientation, religion or other similar beliefs, and/or social-economic background. We will do this only
            where appropriate and in accordance with local laws and requirements.
          </span>
        </p>
        <p className="c18">
          <span className="c0">
            This information is what is called ‘special categories’ of personal data (this is also known as sensitive
            personal data). We may need to obtain your explicit consent before we can collect it. We will ask for your
            consent by offering you an opt-in. This means that you have to explicitly and clearly tell us that you agree
            to us collecting and using this information.
          </span>
        </p>
        <p className="c18">
          <span className="c0">
            We may collect other special categories of personal data about you, such as health-related information. We
            will never do this without your explicit consent.
          </span>
        </p>
        <p className="c18">
          <span className="c12 c29">
            If you would like to find out more about the rules which apply in relation to consent, see Section 13.2 (
          </span>
          <span className="c12 c27 c29">Consent</span>
          <span className="c0">).</span>
        </p>
        <p className="c18">
          <span className="c12 c29">
            If you are not happy about this, you have the right to withdraw your consent at any time. See Section 12 (
          </span>
          <span className="c12 c27 c29">
            How can you access, amend, or take back the personal data that you have given to us?
          </span>
          <span className="c0">).</span>
        </p>
        <ol className="c7 lst-kix_list_8-1" start={9}>
          <li className="c14 li-bullet-16">
            <h2 style={{ display: 'inline' }}>
              <span className="c15 c2">How do We Store and Transfer Your Data Internationally?</span>
            </h2>
          </li>
        </ol>
        <p className="c18">
          <span className="c0">
            We want to make sure that your data is stored and transferred in a way that is secure. We will therefore
            only transfer data overseas where it is compliant with data protection legislation and the means of transfer
            provides adequate safeguards in relation to your data. For example:
          </span>
        </p>
        <ul className="c7 lst-kix_list_3-0">
          <li className="c4 li-bullet-2">
            <span className="c0">
              By data transfer agreement, incorporating applicable standard contractual clauses for the transfer of
              personal data to data controllers and processors in jurisdictions which do not benefit from a finding of
              adequacy (see next paragraph).
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              Transferring your data to a country where there has been a finding of adequacy by the European Commission
              or the United Kingdom's data protection supervisory authority in respect to that country's levels of data
              protection via its legislation.
            </span>
          </li>
          <li className="c4 li-bullet-2">
            <span className="c0">
              To the extent applicable, by way of scheme approved by the European Commission or under relevant UK
              legislation, whether as a successor to the EU-US Privacy Shield or scheme which otherwise permits the
              exchange of personal data between jurisdictions.
            </span>
          </li>
          <li className="c4 li-bullet-1">
            <span className="c0">
              Where it is necessary for the conclusion or performance of a contract between ourselves and a third party
              and the transfer is in your interest for the purposes of that contract (e.g., if we need to transfer data
              in order to meet our obligations under that contract).
            </span>
          </li>
          <li className="c4 li-bullet-10">
            <span className="c0">Where you have consented to the data transfer.</span>
          </li>
        </ul>
        <ol className="c7 lst-kix_list_8-0" start={14}>
          <li className="c45 li-bullet-13">
            <h1 id="h.4i7ojhp" style={{ display: 'inline' }}>
              <span className="c15 c2">Definitions</span>
            </h1>
          </li>
        </ol>
        <a id="t.6505e04781b88e5b38673aa958b91d982c679c47" />
        <a id="t.1" />
        <table className="c54">
          <thead>
            <tr className="c17">
              <td className="c16 c52" colSpan={1} rowSpan={1}>
                <p className="c36">
                  <span className="c15 c2">Term</span>
                </p>
              </td>
              <td className="c9 c52" colSpan={1} rowSpan={1}>
                <p className="c36">
                  <span className="c15 c2">Definition</span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody />
          <tbody>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">Retailers</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">
                    Refers to retailers which use the Markato Platform to browse and/or purchase goods made available on
                    the Markato Platform (in each case, including individuals who are acting on behalf of the
                    retailers).
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">Brands</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">
                    Refers to brands which make their goods available for purchase on the Markato Platform (in each
                    case, including individuals who are acting on behalf of the brands).
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">EU General Data Protection Regulation (EU GDPR)</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">
                    EU General Data Protection Regulation (2016/679) is a statutory instrument which aims to harmonise
                    European data protection laws. It was effective from 25 May 2018, and any references to it should be
                    read accordingly to include any national legislation implementing it.
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">HK PDPO</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">
                    Hong Kong Personal Data (Privacy) Ordinance (Cap. 486), as amended from time to time.
                  </span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">SG PDPA</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">Singapore Personal Data Protection Act 2012, as amended from time to time.</span>
                </p>
              </td>
            </tr>
            <tr className="c17">
              <td className="c16" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">UK General Data Protection Regulation (UK GDPR)</span>
                </p>
              </td>
              <td className="c9" colSpan={1} rowSpan={1}>
                <p className="c8">
                  <span className="c0">
                    The General Data Protection Regulation (Regulation (EU) 2016/679) as it forms part of the law of
                    England and Wales, Scotland and Northern Ireland by virtue of section 3 of the European Union
                    (Withdrawal) Act 2018, as amended by the Data Protection Act 2018 and the Data Protection, Privacy
                    and Electronic Communications (Amendments etc) (EU Exit) Regulations 2019 as amended from time to
                    time.
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="c18 c33">
          <span className="c0" />
        </p>
        <div></div>
      </div>
    </main>
  )
}

export default PrivacyPolicy


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy-policy/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  